import { useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "../../lib/cn";
import { pageTitle } from "./navigation";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

const DESKTOP_QUERY = "(min-width: 768px)";

const isDesktop = (): boolean => window.matchMedia(DESKTOP_QUERY).matches;

export const AppShell = ({ children }: { children: ReactNode }) => {
	const [sidebarOpen, setSidebarOpen] = useState(isDesktop);
	const { pathname } = useLocation();

	const closeOnMobile = () => {
		if (!isDesktop()) setSidebarOpen(false);
	};

	return (
		<div className="flex min-h-screen bg-canvas">
			{sidebarOpen ? (
				<>
					<div
						className="fixed inset-0 z-30 bg-ink/30 backdrop-blur-sm md:hidden"
						onClick={() => setSidebarOpen(false)}
						aria-hidden
					/>
					<div className="fixed inset-y-0 left-0 z-40 border-r border-line md:sticky md:top-0 md:z-auto md:h-screen md:border-r-0">
						<Sidebar onNavigate={closeOnMobile} />
					</div>
				</>
			) : null}

			<div className={cn("flex min-w-0 flex-1 flex-col p-2", sidebarOpen && "md:pl-0")}>
				<div className="flex min-h-[calc(100vh-1rem)] flex-col rounded-lg border border-line bg-surface shadow-[0_10px_30px_rgba(11,58,107,0.06)]">
					<TopBar
						title={pageTitle(pathname)}
						onToggleSidebar={() => setSidebarOpen((open) => !open)}
					/>
					<div className="flex-1 px-6 py-6">{children}</div>
				</div>
			</div>
		</div>
	);
};
